// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons-container {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.icons-container img {
  width: 20px;
  height: 20px;
}

.public-game-username-text {
  font-size: 10px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Components/PublicGameButtonGroup/PublicGameButtonGroup.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".icons-container {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.icons-container img {\n  width: 20px;\n  height: 20px;\n}\n\n.public-game-username-text {\n  font-size: 10px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
